import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { FundInvestmentSummaryCellData } from 'pages/FundInvestments/hooks/useFundInvestmentSummarySheet';

const normalizeFundCell = (cell: ICell<FundInvestmentSummaryCellData>): void => {
  Object.assign(cell, {
    dataEditor: undefined,
    dbType: 'string', // For DecimalField
    dropdown: false,
    gridType: 'number',
    isEditableTitleCell: false,
    isRequired: false,
    readOnly: false,
    useScalarSpreadsheetCell: false,
    valueViewer: undefined,
  });
};

export default normalizeFundCell;
